import { render, staticRenderFns } from "./create.vue?vue&type=template&id=7f226134&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=7f226134&lang=scss&scoped=true&"
import style1 from "./create.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./create.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f226134",
  null
  
)

export default component.exports